import { GeofenceParamsType } from '../types/geofence.type'
import TrackProAPI from './track-pro-api'

interface SaveGeofenceType {
    data: GeofenceParamsType
    editGeofence?: boolean
}

const saveGeofence = (geofenceParams: SaveGeofenceType) => {
    const { editGeofence } = geofenceParams
    const { asset_id, coordinates, shape, name, radius, geofence_id } =
        geofenceParams.data
    const endpoint = editGeofence ? '/geofences/update' : '/geofences/create'
    let params = {
        coordinates,
        shape,
        name,
        radius,
    }
    let data
    if (editGeofence) data = { ...params, geofence_id }
    else data = { ...params, asset_id }
    return TrackProAPI.post(endpoint, data)
}

const deleteGeofence = async (geofence_id: number) => {
    const endpoint = '/geofences/delete'
    const { data } = await TrackProAPI.delete(endpoint, {
        data: { geofence_id },
    })
    return data
}

export default {
    saveGeofence,
    deleteGeofence,
}
